import { render, staticRenderFns } from "./LeadView.vue?vue&type=template&id=d82f4d86&"
import script from "./LeadView.vue?vue&type=script&lang=js&"
export * from "./LeadView.vue?vue&type=script&lang=js&"
import style0 from "./LeadView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d82f4d86')) {
      api.createRecord('d82f4d86', component.options)
    } else {
      api.reload('d82f4d86', component.options)
    }
    module.hot.accept("./LeadView.vue?vue&type=template&id=d82f4d86&", function () {
      api.rerender('d82f4d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/LeadView.vue"
export default component.exports